import React, { useEffect, useRef } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icon from '~/Common-Objects/UI/Icon'
import Icons from '~/Common-Objects/UI/Icons/index'
import { humanizeBytes, humanizeDuration, validateVideo } from './shared'
import axios from '~/data/http/axios'

export default function VideoSelect({ VideoId, video, onRemove = () => {}, setVideo = () => {} }) {
    const timer = useRef()

    const getVideo = async () => {
        if (timer.current) clearTimeout(timer.current)
        const res = await axios.get(`/video/${VideoId}`)
        setVideo(res.data)
        if (res.data.status < 4) {
            timer.current = setTimeout(() => {
                getVideo()
            }, 1000)
        }
    }

    useEffect(() => {
        if (VideoId) getVideo()
        return () => {
            clearTimeout(timer.current)
        }
    }, [])

    const videoError = validateVideo(video)

    let status = video?.status
    if (video?.meta && !status) status = 4

    return (
        <div className='mar-b20'>
            <label className='txtInput_label'>Video</label>
            {!!video && (
                <div
                    className='quickFlex'
                    style={{
                        alignItems: 'center',
                        border: '1px solid var(--neutral-300)',
                        borderRadius: 8,
                        padding: '12px 16px',
                        gap: 16
                    }}
                >
                    <Icons icon='video' color='black' outerStyle={{ height: 20 }} />
                    <div style={{ display: 'block', flexGrow: 1, textAlign: 'left' }}>
                        <div>{video.filename}</div>
                        <div style={{ color: 'var(--neutral-800)' }}>
                            {!!video.meta && (
                                <span>
                                    {humanizeDuration(video.meta.duration)} &#8901; {video.meta.video.width}x
                                    {video.meta.video.height}
                                </span>
                            )}
                            {!video.meta && humanizeBytes(video.filesize)}
                        </div>
                    </div>
                    {status === 4 && (
                        <Button
                            className='button-red-ghost button-sml'
                            iconLeft={<Icons icon='bin' color='var(--red-600)' />}
                            onClick={onRemove}
                        >
                            Remove
                        </Button>
                    )}
                    {(status === 1 || status === 2) && (
                        <div className='quickFlex'>
                            <span className='mar-r10 loading'>Scanning video</span>
                            <Icon name='loading' color='var(--indigo-800)' />
                        </div>
                    )}
                    {status === 3 && (
                        <div className='quickFlex'>
                            <span className='mar-r10 loading'>Extracting thumbnails</span>
                            <Icon name='loading' color='var(--indigo-800)' />
                        </div>
                    )}
                    {status === 99 && (
                        <div className='quickFlex'>
                            <span className='mar-r10 text-red text-heavy'>{video.error}</span>
                            <Button
                                className='button-red-ghost button-sml'
                                iconLeft={<Icons icon='bin' color='var(--red-600)' />}
                                onClick={onRemove}
                            >
                                Remove
                            </Button>
                        </div>
                    )}
                </div>
            )}
            {videoError}
        </div>
    )
}
